import { setGlobalVar } from "../global/globalUtils";
import { VIEWERFEATURE } from "./debugMenu";
import { writeDebugMenuEntry } from "./debugMenuFunctions";
class FrontEndModulesHolder {
}
export class globalsObject {
}
globalsObject.frontendModules = new FrontEndModulesHolder();
export default globalsObject;
export function translate(id, alternative) {
    return globalsObject.localizer.translate(id, alternative);
}
export function trackPageview(url) {
    globalsObject.googleTracker.trackPageview(url);
}
export function getEmailFromActiveUser() {
    let email = globalsObject.controller.model.user.getEmail();
    return email || "";
}
export function handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClose) {
    globalsObject.errorHandler.handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClose);
}
setGlobalVar("trackPageview", trackPageview);
setGlobalVar("getEmailFromActiveUser", getEmailFromActiveUser);
export function initControllerDebugFunctions(controller, actionController, productController) {
    VIEWERFEATURE.SPEICHERE_ENTWURF_FUER_KUNDENKONFI = {
        displayString: function () {
            return writeDebugMenuEntry('VIEWERFEATURE.SPEICHERE_ENTWURF_FUER_KUNDENKONFI.display();', "Kundenkonfi Entwurf speichern");
        },
        display: function () {
            $("<div id='kundenKonfi_saveDraft'>" +
                "<label>Kundenkonfi Name:</label><input type='text' id='kundenKonfiName'>" +
                "<button onclick='$(\"#kundenKonfi_saveDraft\").remove();'>Cancel</button><br><button onclick='VIEWERFEATURE.SPEICHERE_ENTWURF_FUER_KUNDENKONFI.saveIt()'>Speichern</button>" +
                "   </div>").appendTo("body");
        },
        saveIt: function () {
            const kundenKonfiName = $("#kundenKonfiName").val();
            if (kundenKonfiName === '') {
                alert("bitte KonfiNamen eingeben!!");
                return false;
            }
            controller.selObController.makeAllLogosAndTextsUntouchable();
            globalsObject.actionController.saveEntwurf(false).then(function () {
                $.post("/konfigurator_php/debug/write_KK_EntwurfsVorbelegung.php", {
                    DreiDModell: controller.model.getCurrentOwayoProduct().model,
                    saveID: controller.model.entwurf.getID(),
                    KundenKonfi: kundenKonfiName
                })
                    .done(function () {
                    alert("done");
                    $("#kundenKonfi_saveDraft").remove();
                });
            });
            return true;
        }
    };
    VIEWERFEATURE.WRITE_LEGACYFONTS_FOR_CURRENT_LOGIN = {
        displayString: function () {
            return writeDebugMenuEntry('VIEWERFEATURE.WRITE_LEGACYFONTS_FOR_CURRENT_LOGIN.write()', "LegcyFonts für diesen User schreiben");
        },
        write: function () {
            if (controller.model.user.isLoggedIn() === false) {
                alert("nicht eingeloggt");
                return;
            }
            const login = controller.model.user.getUserName();
            $.get("/konfigurator_php/debug/writeLoginLegacyFonts.php?login=" + login, result => alert("legacyFonts geschrieben für" + login + ":" + result));
        }
    };
    VIEWERFEATURE.LOG_COLOROBJECT = {
        displayString: () => {
            return "<li>console.log Corlocode<input id='debug_logcolorcode' type='text' onchange='VIEWERFEATURE.LOG_COLOROBJECT.execute()'></li>";
        },
        execute() {
            const input = $("#debug_logcolorcode");
            const colorCode = input.val().toLowerCase();
            if (colorCode === "") {
                return;
            }
            console.log(controller.model.entwurf.getColorObjects().filter(c => c.colorCode.toLowerCase().indexOf(colorCode.toLowerCase()) !== -1));
            input.val("");
        }
    };
    VIEWERFEATURE.SHOW_EMPTY_HIGHLIGHTS = {
        displayString: function () { return writeDebugMenuEntry('VIEWERFEATURE.SHOW_EMPTY_HIGHLIGHTS.show();', "fehlende Highlights in Produktauswahl anzeigen"); },
        getEmptyFeatureStrings: (featuredObjectName, features) => {
            return features.reduce((carry, f) => {
                if (f.detailImageURL === "img/emptyHighlight.png") {
                    return carry + featuredObjectName + ": " + f.Feature + "; ";
                }
                return carry;
            }, "");
        },
        show: async function () {
            // noinspection EqualityComparisonWithCoercionJS
            const produkteMitAuswaehlbarenFeaturedObjects = productController.produkte.getAuswahlProdukte().filter(p => p.FeaturedObjects
                .some(f => f.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn !== "0"));
            const produkteMitFehlendenHighlights = produkteMitAuswaehlbarenFeaturedObjects.filter(p => p.FeaturedObjects.some(fo => fo.Features.some(f => f.detailImageURL === "img/emptyHighlight.png")));
            const messageParts = produkteMitFehlendenHighlights.reduce((carry, p) => {
                // noinspection EqualityComparisonWithCoercionJS
                const foMessages = p.FeaturedObjects.filter(fo => fo.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn !== "0")
                    .map(fo => VIEWERFEATURE.SHOW_EMPTY_HIGHLIGHTS.getEmptyFeatureStrings(fo.FeaturedObject, fo.Features)).filter(m => m !== "");
                if (foMessages.length > 0) {
                    carry.push([p.Produkt, foMessages.join("")].join("\n"));
                }
                return carry;
            }, []);
            if (messageParts.length === 0) {
                alert("alles da :)");
                return;
            }
            alert(messageParts.join("\n\n"));
            await navigator.clipboard.writeText(messageParts.join("\n\n"));
        }
    };
}
//# sourceMappingURL=globalsObject.js.map